// extracted by mini-css-extract-plugin
export default {"container":"TV-z","title":"UV-z","link":"VV-z"};